import {createFileRoute, redirect} from '@tanstack/react-router'
import {isAuthenticated} from "../utils/auth.ts";
import OnboardingPage from "../components/Onboarding/OnboardingPage.tsx";

export const Route = createFileRoute('/onboarding')({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: OnboardingPage
});
